import React from "react";
import "../css/style.css";
import "../css/bootstrap.css";
import { NavLink } from "react-router-dom";
import { HiOutlineHome } from "react-icons/hi2";

const Footer = () => {
  return (
    <div className="footer bg-white shadow mt-auto border-top">
      <div className="d-flex align-items-center justify-content-between py-1">
        <NavLink
          to="/home"
          className={({ isActive }) =>
            `text-center col py-2 p-1 text-decoration-none ${
              isActive ? "active-tab" : "text-muted"
            }`
          }
        >
          <HiOutlineHome className="d-block mx-auto" size={30} strokeWidth={2} />
          <p className="small m-0 pt-1">Home</p>
        </NavLink>

        <NavLink
          to="/quality-assurance"
          className={({ isActive }) =>
            `text-center col py-2 p-1 text-decoration-none ${
              isActive ? "active-tab" : "link-dark"
            }`
          }
        >
          <i className="bi bi-shield-check d-block h3 m-0"></i>
          <p className="small m-0 pt-1">QA</p>
        </NavLink>

        <NavLink
          to="/faq"
          className={({ isActive }) =>
            `text-center col py-2 p-1 text-decoration-none ${
              isActive ? "active-tab" : "link-dark"
            }`
          }
        >
          <i className="bi bi-info-circle d-block h3 m-0"></i>
          <p className="small m-0 pt-1">FAQs</p>
        </NavLink>

        <NavLink
          to="/products"
          className={({ isActive }) =>
            `text-center col py-2 p-1 text-decoration-none ${
              isActive ? "active-tab" : "link-dark"
            }`
          }
        >
          <i className="bi bi-box d-block h3 m-0"></i>
          <p className="small m-0 pt-1">My Product</p>
        </NavLink>
      </div>
    </div>
  );
};

export default Footer;
